module.exports = __webpack_public_path__ + "static/media/015.320a6e36.jpg";